export default __webpack_public_path__ + "static/media/icon_radio_normal.5a463495.svg";